<template>
  <v-footer padless app dark tile class="memberNavigationBar">
    <v-btn-toggle
      active-class="active"
    >
      <v-btn to="/category/story">
        <v-icon>fa-book-open</v-icon>
        動態
      </v-btn>
      <v-btn to="/">
        <v-icon>fa-home</v-icon>
        首頁
      </v-btn>
      <v-btn to="/chats">
        <v-icon>fa-comment</v-icon>
        聊天
      </v-btn>
      <v-btn to="/profile">
        <v-icon>fa-user</v-icon>
        會員
      </v-btn>
    </v-btn-toggle>
  </v-footer>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.memberNavigationBar {
  .v-btn-toggle {
    flex-grow: 1;
    align-items: center;
  }
  .v-btn {
    border-radius: 0;
    border-color: transparent !important;
    border-width: 0 !important;
    flex: 1 1 0;
    height: 55px !important;
    .v-btn__content {
      flex-direction: column;
      font-size: 10px;
      font-weight: 300;
      i {
        font-size: 20px;
        margin-bottom: 2px;
      }
    }
  }
  .active {
    .v-btn__content, i {
      color: $main !important;
    }
    &::before {
      background-color: transparent;
    }
  }
}
</style>